import { api } from "./api";

const actions = {
	/**
	 * Start a vector migration
	 * @param {Object} data - The migration data
	 * @param {Function} onSuccess - Callback for successful migration
	 * @param {Function} onFailure - Callback for failed migration
	 * @returns {Function} - Dispatch function for the API call
	 */
	startVectorMigration: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/vector/migration`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
